module.exports = __webpack_public_path__ + "img/data-variable.7e12587b.svg";